/**
 * Scroll Reveal — Animations au défilement
 * Utilise IntersectionObserver pour animer les éléments [data-reveal]
 * Supporte data-reveal-delay="200" pour des animations décalées
 */
(function () {
  'use strict';

  // Ajouter la classe cachée à tous les éléments à révéler
  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    el.classList.add('reveal-hidden');
  });

  // Observer les éléments pour les animer à l'entrée du viewport
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);

        if (delay > 0) {
          setTimeout(function () {
            el.classList.remove('reveal-hidden');
            el.classList.add('reveal-visible');
          }, delay);
        } else {
          el.classList.remove('reveal-hidden');
          el.classList.add('reveal-visible');
        }

        // Ne plus observer une fois révélé
        observer.unobserve(el);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    observer.observe(el);
  });
})();
